import React, { Component } from 'react';
import '../myutils';
import {
  SelectInput,
  SimpleForm,
  TextInput,
  translate,
  FormDataConsumer
} from 'react-admin';

import BookIcon from '@material-ui/icons/Book';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FileUpload from '@material-ui/icons/CloudUpload';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import { ReactMic } from '@cleandersonlobo/react-mic';
import MicrophoneOn from '@material-ui/icons/Mic';
import MicrophoneOff from '@material-ui/icons/MicOff';
import { configAPI } from '../config'
import DropzoneComponent from 'react-dropzone';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
import { refreshView as refreshViewAction } from 'ra-core';
import CircularProgress from '@material-ui/core/CircularProgress';

export const TemplateIcon = BookIcon;

class RecUploader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      ttsContent: false,
      uploadStarted: false,
      uploadComplete: false,
      uploadFailed: false,
      record: false,
      messageType: 'A'
    }
  }

  componentDidMount() {
    var request;

    if (this.props.msg === 1) {
      request = new Request(configAPI.api.prod + '/DownloadFile?&path=' + this.props.record.id + '.tts&token=' + sessionStorage.B.encodeDecode(), {
        headers: new Headers({
          'Content-Type': 'text/json'
        }),
        method: 'GET'
      });
    }
    if (this.props.msg === 2) {
      request = new Request(configAPI.api.prod + '/DownloadFile?&path=' + this.props.record.id + '-MoreInfo.tts&token=' + sessionStorage.B.encodeDecode(), {
        headers: new Headers({
          'Content-Type': 'text/json'
        }),
        method: 'GET'
      });
    }

    fetch(request).then(data => data.text())
      .then(data => {
        if (data !== 'Requested file does not exist') this.setState({ ttsContent: data })
      }, (error) => {
        if (error) {
          this.setState({ ttsContent: false })
        }
      });
  }

  componentWillReceiveProps() {
    if (this.props.msg === 3) {
      this.setState({ path: this.props.record.path });
      this.setState({ key: Math.random() * 10000 });
    }
  }

  startRecording = () => {
    this.setState({
      record: true
    });
  }

  stopRecording = () => {
    this.setState({
      record: false
    });
  }

  onData(recordedBlob) {
  }

  onStop = (recordedBlob) => {
    this.setState({
      newRecording: recordedBlob.blob
    })
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    const { refreshView } = this.props;
    this.setState({ open: false, uploadComplete: false, uploadStarted: false, uploadFailed: false });
    if (this.props.resource === 'Templates') {
      refreshView();
    }
  };

  handleMessageChange = (e) => {
    this.setState({ message: e.target.value });
  };

  handleMessageTypeChange = (e) => {
    this.setState({ messageType: e[0] });
  };

  onDrop = (files) => {
    this.setState({ selectedFile: files[files.length - 1] })
  }

  handleSendSubmit = () => {
    const { message, messageType } = this.state;
    var dataU = new FormData();
    var dataD = new FormData();
    dataU.append("token", sessionStorage.B.encodeDecode());
    dataD.append("token", sessionStorage.B.encodeDecode());
    var path = '';
    switch (this.props.resource) {
      case 'Templates':
        switch (this.props.msg) {
          case 1:
            path = this.props.record.id;
            break;
          case 2:
            path = this.props.record.id + '-MoreInfo';
            break;
          default:
            break;
        }
        break;
      case 'IVR':
        path = this.record.path;
        break;
      default:
        break;
    }

    switch (messageType) {
      case 'T':
        var blob = new Blob([message], { type: 'text/plain' });
        dataU.append("upload", blob);
        dataU.append("path", path + '.tts');
        (this.props.msg===1)&&dataD.append("what", 'tpl:' + path +':msg');
        (this.props.msg===2)&&dataD.append("what", 'tpl:' + path.replace('-MoreInfo','') +':moreinfo');
        break;
      case 'A':
        dataU.append("upload", this.state.selectedFile);
        dataU.append("path", path + '.wav');
        (this.props.msg===1)&&dataD.append("what", 'tpl:' + path +':tts');
        (this.props.msg===2)&&dataD.append("what", 'tpl:' + path.replace('-MoreInfo','') +':ttsmoreinfo');
        break;
      case 'R':
        dataU.append("upload", this.state.newRecording);
        dataU.append("path", path + '.wav');
        (this.props.msg===1)&&dataD.append("what", 'tpl:' + path +':tts');
        (this.props.msg===2)&&dataD.append("what", 'tpl:' + path.replace('-MoreInfo','') +':ttsmoreinfo');
        // data.append("convertAudio", '1');
        break;
      default:
        break;
    }
    this.setState({ uploadStarted: true })
    fetch(configAPI.api.prod + 'UploadFile', {
      method: "POST",
      body: dataU
    }).then(response => response.json())
      .then(json => {
        if (json.responseStatus === 'OK') {
          this.setState({ uploadComplete: true, uploadStarted: false });
        } else {
          this.setState({uploadFailed: true})
        }
      })
      .catch((e) => {
      });
    dataD.append("action", "delete");
    fetch(configAPI.api.prod + 'FileAction', {
        method: "POST",
        body: dataD
      }).then(response => response.json())
  }

  render() {
    const { translate } = this.props;
    return (
      <div>
        {(this.props.msg < 3) &&  <h3>{translate(`resources.templates.uploader` + this.props.msg)}</h3>}
        <br /><br />
        {((this.props.msg === 1)&&(this.state.ttsContent===false)) && <><audio controls>
          <source src={configAPI.api.prod + '/DownloadFile?&path=' + this.props.record.id + '.wav&token=' + sessionStorage.B.encodeDecode()} type="audio/ogg" />
        </audio>
        {/* <IconButton onClick={this.handleClickOpen}>
        <FileUpload color="primary" />
        </IconButton>
          <DeleteFile record={{ what: 'tpl:' + this.props.record.id + ':msg' }} /> */}
        </>}
        {((this.props.msg === 2)&&(this.state.ttsContent===false)) && <><audio controls>
          <source src={configAPI.api.prod + '/DownloadFile?&path=' + this.props.record.id + '-MoreInfo.wav&token=' + sessionStorage.B.encodeDecode()} type="audio/ogg" />
        </audio>
        {/* <IconButton onClick={this.handleClickOpen}>
        <FileUpload color="primary" />
        </IconButton>
          <DeleteFile record={{ what: 'tpl:' + this.props.record.id + ':moreinfo' }} /> */}
        </>}
        {((this.props.msg === 3)&&(this.state.ttsContent===false)) && <><audio controls key={this.state.path} style={{ marginLeft: '20%' }}>
          <source src={configAPI.api.prod + '/DownloadFile?&path=' + this.state.path + '&token=' + sessionStorage.B.encodeDecode()} type="audio/ogg" />
        </audio>
        {/* <IconButton onClick={this.handleClickOpen}>
        <FileUpload color="primary" />          
        </IconButton>
          <DeleteFile record={{ what: this.state.path }} /> */}
        </>}

        {(this.state.ttsContent!==false)&&(<TextField
          id="ttsContent"
          label=""
          defaultValue={this.state.ttsContent}
          // className={classes.textField}
          margin="normal"
          InputProps={{
            readOnly: true,
          }}
        />)}
        <br/>
        <Button variant="outlined" onClick={this.handleClickOpen}>
        {translate(`resources.templates.uploadCampaignMessage` + this.props.msg)}<FileUpload color="primary" />
        </Button>
        {/* {((this.state.ttsContent!==false)&&(this.props.msg === 1))&&(<DeleteFile record={{ what: 'tpl:' + this.props.record.id + ':tts' }} />)}
        {((this.state.ttsContent!==false)&&(this.props.msg === 2))&&(<DeleteFile record={{ what: 'tpl:' + this.props.record.id + ':ttsmoreinfo' }} />)} */}
        {(this.state.uploadStarted) && (<CircularProgress size={100} />)}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
          {(this.state.uploadFailed)&&(
            <Grid container justify="center">
            <Typography color="secondary" variant="display2">{translate('trans.uploadFailed')}</Typography>
          </Grid>
          )}
          {(this.state.uploadComplete) ?
            (<Grid container justify="center">
              <Typography color="secondary" variant="display2">{translate('trans.uploadDone')}</Typography>
            </Grid>) :
            (<>
              <h2>{translate(`resources.templates.chooseFileType`)}</h2>
              <SimpleForm
                toolbar={false}
                defaultValue={{ average_note: 0 }}
              >
                <SelectInput source="message_type" choices={[
                  { id: 'TTS', name: translate(`resources.templates.writtenMessage`) },
                  { id: 'AUDIO', name: translate(`resources.templates.audio`) },
                  { id: 'RECORDING', name: translate(`resources.templates.recording`) }
                ]} onChange={this.handleMessageTypeChange} />
                <FormDataConsumer>
                  {({ formData, ...rest }) => (formData.message_type === "TTS" && this.state.messageType === 'T') &&
                    <TextInput source="message" options={{ multiLine: true }} onChange={this.handleMessageChange} {...rest} />
                  }
                </FormDataConsumer>
                <FormDataConsumer>
                  {({ formData, ...rest }) => (formData.message_type === "AUDIO" && this.state.messageType === 'A') &&
                    <DropzoneComponent onDrop={this.onDrop} />
                  }
                </FormDataConsumer>
                <FormDataConsumer>
                  {({ formData, ...rest }) => (formData.message_type === "RECORDING" && this.state.messageType === 'R') &&
                    <div>
                      <ReactMic
                        record={this.state.record}
                        className="sound-wave"
                        onStop={this.onStop}
                        onData={this.onData}
                      />
                      <Button
                        onClick={this.startRecording}>
                        <MicrophoneOn />
                      </Button>
                      <Button
                        onClick={this.stopRecording}>
                        <MicrophoneOff />
                      </Button>
                    </div>
                  }
                </FormDataConsumer>
              </SimpleForm>
              <br></br>
              <DialogActions>
                <Button onClick={(e) => this.handleSendSubmit(e)} color="primary">
                  {translate('ra.action.ok')}
                </Button>
              </DialogActions>
            </>)}
        </Dialog>
      </div>
    );
  }
}

const enhance = connect(
  null,
  { refreshView: refreshViewAction }
);

export default enhance(connect(null, {
  push: pushAction,
})(translate(RecUploader)));